module.exports = __webpack_public_path__ + "img/588.a44fbea2.png";